import React, { useState, useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";

const TaxRate = ({
  contributiTotali,
  imposteTotali,
  fatturato,
  taxRateTotale,
  setTaxRateTotale,
}) => {
  const [taxRateContributi, setTaxRateContributi] = useState();
  const [taxRateImposta, setTaxRateImposta] = useState();

  useEffect(() => {
    if (fatturato !== 0) {
      setTaxRateContributi((contributiTotali / fatturato) * 100);
      setTaxRateImposta((imposteTotali / fatturato) * 100);
    } else {
      setTaxRateContributi((contributiTotali / 1) * 100);
      setTaxRateImposta((imposteTotali / 1) * 100);
    }
  }, [
    contributiTotali,
    imposteTotali,
    fatturato,
    setTaxRateImposta,
    setTaxRateContributi,
  ]);

  useEffect(() => {
    setTaxRateTotale(taxRateContributi + taxRateImposta);
  }, [taxRateImposta, taxRateContributi, setTaxRateTotale]);

  return (
    <>
      <div className="pb-2 text-left">
        <span>
          Il tax rate indica quanto devi mettere da parte in tasse per ogni
          fattura
        </span>
      </div>
      <LabelValueRow
        label={"Contributi"}
        value={`${taxRateContributi}`}
        type="perc"
      />
      <LabelValueRow
        label={"Imposta"}
        value={`${taxRateImposta}`}
        type="perc"
      />
      <LabelValueRow
        label={"Totale"}
        value={`${taxRateTotale}`}
        type="perc"
        important={true}
      />
    </>
  );
};

export default TaxRate;
